import { defineStore } from 'pinia'

export const socketFun = defineStore('socketFun', {
  state: () => {
    return{
      vuexSocket: ''
    }
  },
  actions: {
    setVuexSocket(data){
      this.vuexSocket = data;
    }
  }
})
export const numberFun = defineStore('numberFun', {
  state: () => {
    return{
      numberValue: ''
    }
  },
  actions: {
    setNumberFun(data){
      this.numberValue = data;
    }
  }
})